const UtilMixin = {
  methods: {
    to(route) {
      this.$router.push(route);
    },
    abort() {
      this.$router.push('/');
    }
  }
};
export default UtilMixin;
